export interface IFilter {
  [key: string]: string[];
}

export interface IFiltersState {
  expanded: string[];
  savedSearchValue: string;
}

export enum FiltersActionTypes {
  SAVE_FILTER = '@@filters/SAVE_FILTER',
  REMOVE_FILTER = '@@filters/REMOVE_FILTER',
  CLEAR_ALL_FILTERS = '@@filters/CLEAR_ALL_FILTERS',
  ADD_EXPANDED = '@@filters/ADD_EXPANDED',
  REMOVE_EXPANDED = '@@filters/REMOVE_EXPANDED',
  SAVE_SEARCH_VALUE = '@@filters/SAVE_SEARCH_VALUE',
}
